import { _ } from "libs";

import React from "react";
import { unregister } from "../serviceWorker";

const forceReload = () => {
	window.location.reload();
};

export const NewVersionPopup = () => {
	const onClick = () => {
		unregister(forceReload);
	};

	return (
		<div className="stickyAlerts">
			<div className="stickyAlert">
				<h5>{_("newVersion.heading")}</h5>
				<p>
					{_("newVersion.text")}
					&nbsp;
					<span className="link plain" onClick={onClick}>
						{_("reloadAppBtn")}
					</span>
				</p>
			</div>
		</div>
	);
};

export const RandomAlert = () => {
	return (
		<div className="stickyAlerts">
			<div className="stickyAlert">
				<h5>Notice</h5>
				<p>
					Aufgrund eines Ausfalls beim Zahlungsverarbeiter sind Zahlungen per Kreditkarte zur Zeit nicht
					verfügbar. Bitte nutze die Bezahlung ‘vor Ort’ falls von der Anlage angeboten. Wir entschuldigen uns
					für die Unannehmlichkeiten und arbeiten mit Hochdruck an einer Lösung. Wir informieren Dich
					baldmöglichst.
				</p>
				<p>&nbsp;</p>
				<p>
					Due to an outage at our payment processing provider payments by credit card are currently
					unavailable. Please use the &apos;on site&apos; payment option if available. We apologize for any
					inconvenience caused and are working hard to provide solutions. We&apos;ll keep you informed as we
					make progress.
				</p>
			</div>
		</div>
	);
};
